import {useEffect, useState} from "react";
import {View} from "../react-native-components-in-react/react-native-components-in-react";

import './bottom-action-bar.css'

const BottomActionBar = ({children, style = {}, containerStyle = {}}) => {
    const [moveToTop, setMoveToTop] = useState(false);

    const useScroll = () => {
        const [scrollY, setScrollY] = useState(0);

        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        useEffect(() => {
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);

        return scrollY;
    };

    const scrollY = useScroll();

    useEffect(() => {
        setMoveToTop(scrollY > 1);
    }, [scrollY]);

    return <View
        className={`bottom-action-bar ${moveToTop ? "bottom-action-bar-hidden" : ""}`}
        style={{ justifyContent: 'center', alignItems: 'center', ...style }}
    >
        <View
            className={'bottom-action-bar-container'}
            style={containerStyle}
        >
            {children}
        </View>
    </View>
}

export default BottomActionBar;